import React from 'react'
import './service.css'
import {FaCheckCircle} from 'react-icons/fa'

const Service = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>services</h2>

      <div className='container services__container'>
       <article className='service'>
        <div className='service__head'>
          <h3>Web Development</h3>
        </div>

        <ul className='service__list'>
          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Website Designs and Development</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Frontend Development</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Backend Development</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Full-Stack Development</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Website Optimization and performance</p>
          </li>
        </ul>
       </article>
{/* END OF WEBDEVELOPMENT */}

<article className='service'>
        <div className='service__head'>
          <h3>API Development</h3>
        </div>

        <ul className='service__list'>
          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>API Designs and Architecture</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>API Development</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>RESTful API Development</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>API Integration</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Authentication and Authorization</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Webhooks and Event-Driven APIs</p>
          </li>
        </ul>
       </article>
       {/* END OF API DEVELOPMENT */}


       <article className='service'>
        <div className='service__head'>
          <h3>Testing and Version Control</h3>
        </div>

        <ul className='service__list'>
          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Unit Texting</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Integration Texting</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Git Repository Setup</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Branch Management</p>
          </li>

          <li>
            <FaCheckCircle className='service__list-icon'/>
            <p>Repository Maintenance and Cleanup</p>
          </li>
        </ul>
       </article>
      </div>
    </section>
  )
}

export default Service